import { setTasksVisualizationNumTasks as setTasksVisualizationNumTasksDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    NumTasks?: Number,
}

export const setTasksVisualizationNumTasks = ({
    NumTasks,
    eventEmitter,
}: Props) => {
    setTasksVisualizationNumTasksDiagram(NumTasks);
};
